import styled from "styled-components";

import { StyledOperatorFieldRow } from "app/pages/sales-intelligence/common-components/dropdown/styles";

export const StyledDropdownsFlexContainer = styled(StyledOperatorFieldRow)`
    & > .autocomplete-industry-codes {
        flex: 1 1 0;
    }
`;
